<script setup lang="ts">
import { type HTMLAttributes, computed } from "vue";
import type { CheckboxRootEmits, CheckboxRootProps } from "radix-vue";
import {
    CheckboxIndicator,
    CheckboxRoot,
    useForwardPropsEmits,
} from "radix-vue";
import { Check } from "lucide-vue-next";
import { cn } from "@/lib/utils";

const props = defineProps<
    CheckboxRootProps & { class?: HTMLAttributes["class"] }
>();
const emits = defineEmits<CheckboxRootEmits>();

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props;

    return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
    <CheckboxRoot
        v-bind="forwarded"
        :class="
            cn(
                'focus-visible:ring-iron-950 dark:ring-offset-iron-950 peer h-4 w-4 border-iron-300 bg-white ring-offset-white disabled:bg-iron-100 disabled:text-iron-300 data-[state=checked]:bg-z-primary-600 data-[state=checked]:text-white data-[state=checked]:disabled:border-iron-300 data-[state=checked]:disabled:bg-iron-100 data-[state=checked]:disabled:text-iron-300 dark:border-iron-800 dark:focus-visible:ring-iron-300 shrink-0 rounded-[4px] border focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none disabled:cursor-not-allowed data-[state=checked]:border-none data-[state=checked]:disabled:border-solid',
                props.class,
            )
        "
    >
        <CheckboxIndicator
            class="flex h-full w-full items-center justify-center text-current"
        >
            <slot>
                <Check stroke-width="4" class="h-3 w-3" />
            </slot>
        </CheckboxIndicator>
    </CheckboxRoot>
</template>
